import { useApiQuery } from '@/api/main/query'
import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'
import { getStorageItem } from '@/shared/lib/storage/localStorage'
import { UniversalCallbackAdminProfile } from '@/entities/callback/model'

export interface CallbacksListParams {
  requisitId?: string;
  anySearch?: string;
  dateFrom?: string;
  dateTo?: string;
  isProcessed?: boolean;
  take?: number;
  skip?: number;
}

export interface UniversalCallbackAdminProfileListResultR {
  items: UniversalCallbackAdminProfile[];
  totalCount: number;
  pageSize: number;
  currentPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export function useCallbacksListQuery(params: CallbacksListParams = {}) {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)
  const shouldFetch = userRole === Roles.Trader

  // Приводим параметры к нужному типу
  const queryParams: Record<string, string | number | boolean | undefined> = {
    ...params,
  }

  const queryKey = ['callbacks-list', userRole, params]

  const query = useApiQuery<UniversalCallbackAdminProfileListResultR>(
    queryKey,
    '/v1/trader/callbacks/list',
    queryParams,
    {
      enabled: shouldFetch,
    }
  )

  return {
    ...query,
    callbacksData: query.data,
    callbacksError: query.error,
    callbacksIsLoading: query.isLoading,
    isTrader: shouldFetch,
    queryKey,
  }
}